import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Grid, MenuItem, Select, useTheme } from "@mui/material";
import DepartmentFiled from "app/components/FieldComponent/Department";
import OrganizationField from "app/components/FieldComponent/Organization";
import { useStyles as useFieldStyles } from "app/components/FieldComponent/styles";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectFeaturePermissions } from "store/global/authPermission/selector";
import { PermissionFeature } from "store/global/authPermission/types";
import { selectList, selectQuery } from "../../redux/selector";
import { actions } from "../../redux/slice";
type Props = {
  isResetRequired: boolean;
};
const FiltersForm = ({ isResetRequired }: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const fieldStyles = useFieldStyles();
  const direction = useTheme().direction;
  const { organizationId, departmentId } = useSelector(selectQuery);
  const { selectedIds, selectedAll } = useSelector(selectList);
  const featurePermissions = useSelector(selectFeaturePermissions);
  const { hasFullAccess } =
    featurePermissions[PermissionFeature.TREATMENT_BANK_LIST];

  const hasSelection = selectedAll || (selectedIds && selectedIds.length > 0);

  const handleBulkStatusChange = (e: any) => {
    const status = e.target.value;
    if (!status) return;
    dispatch(actions.bulkUpdateBankStatus({ status }));
  };

  const setPageQuery = (name: string, value: any) => {
    dispatch(actions.setQuery({ name, value }));
  };

  useEffect(() => {
    if (isResetRequired) {
      dispatch(actions.resetModule());
    }
  }, [dispatch, isResetRequired]);

  return (
    <Grid sx={{ padding: "20px 0px 0px 0px" }}>
      <Grid container spacing={2} md={12} sx={{ paddingBottom: "10px" }}>
        <OrganizationField
          value={organizationId}
          changeValue={(value) => {
            setPageQuery("organizationId", value);
            // setPageQuery("departmentId", "0");
          }}
          showAll={true}
          activeRequired={false}
        ></OrganizationField>

        <DepartmentFiled
          value={departmentId}
          changeValue={(value) => {
            setPageQuery("departmentId", value);
          }}
          orgId={organizationId}
          showAll={true}
          noReset={true}
        ></DepartmentFiled>

        <Grid item xs={2} sx={{ marginLeft: "auto" }}>
          <label className={fieldStyles.label}>
            {t("TREATMENT_BANKS.CHANGE_BANK_STATUS")}
          </label>
          <Select
            margin="dense"
            fullWidth
            variant="outlined"
            displayEmpty
            value=""
            className={fieldStyles.textEnabled}
            disabled={!hasFullAccess || !hasSelection}
            onChange={handleBulkStatusChange}
            IconComponent={KeyboardArrowDownIcon}
          >
            <MenuItem value="" disabled sx={{ direction }}>
              {t("TREATMENT_BANKS.CHANGE_BANK_STATUS")}
            </MenuItem>
            <MenuItem value="New" sx={{ direction }}>
              New
            </MenuItem>
            <MenuItem value="Running" sx={{ direction }}>
              Running
            </MenuItem>
            <MenuItem value="Done" sx={{ direction }}>
              Done
            </MenuItem>
          </Select>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default FiltersForm;
